import { ORIGIN } from "@dpdgroupuk/mydpd-enums";
const BASE_PATH = "/reference";
export default class ReferenceApis {
  constructor(apisClient) {
    this.apis = apisClient;
  }

  async fetchCountries(query, options) {
    return this.apis.get({
      path: `${BASE_PATH}/countries`,
      query,
      options
    });
  }

  async fetchNetworkList(query, options) {
    return this.apis.get({
      path: `${BASE_PATH}/networks`,
      query: {
        hideTimed: true,
        showDesk: false,
        showROI: false,
        exchange: false,
        ...query
      },
      options
    });
  }

  async searchAddresses(query, options) {
    return this.apis.get({
      path: `${BASE_PATH}/addresses`,
      query,
      options
    });
  }

  async searchCollections(query, options) {
    return this.apis.get({
      path: `${BASE_PATH}/collections`,
      query: { ...query,
        origin: ORIGIN.CCTK
      },
      options
    });
  }

  searchParcels(query, options) {
    return this.apis.get({
      path: `${BASE_PATH}/parcels`,
      query: { ...query,
        origin: ORIGIN.PCTK
      },
      options
    });
  }

}